module.exports = __webpack_public_path__ + "static/media/Levin Fabric Wedge_Dark Grey.c269ab6d.png";